import * as React from 'react'
import { RD } from '@packages/prelude'
import { styled } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagic } from '@fortawesome/pro-solid-svg-icons'
import * as domain from '@packages/domain'
import { ControlButton } from '~/components/Buttons'
import { useElevenLabsTTS } from '~/hooks/useElevenLabsTTS'

const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 0.5rem;
`

const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 0.5rem;

  height: 100%;
  justify-content: flex-end;

  > ${ControlButton} {
    font-size: 1.25rem;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 2.5rem;
    height: 100%;
  }
`
const Textarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  border-radius: 1.5rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  font-family: 'Source Sans 3';
  font-size: 1.5rem;
  color: var(--primary);
`

interface Props {
  value: string
  onChange: (value: string) => void
  onAudioGenerated: (blob: Blob) => void
  config: domain.Api.Config.Type
}

export const View: React.FC<React.PropsWithChildren<Props>> = ({ value, onChange, onAudioGenerated }) => {
  const { audio, generateAudio } = useElevenLabsTTS()

  React.useEffect(() => {
    if (RD.isSuccess(audio)) {
      onAudioGenerated(audio.value)
    }
  }, [audio, onAudioGenerated])

  const onGenerateAudio = () => {
    generateAudio(value)()
  }

  return (
    <Container>
      <Textarea
        id="ai-greeting-textarea"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder="Gib hier Deine Wunschbotschaft ein"
      />
      <ButtonContainer>
        <ControlButton onClick={onGenerateAudio} disabled={RD.isPending(audio)}>
          <FontAwesomeIcon icon={faMagic} color={RD.isPending(audio) ? 'red' : ''} />
        </ControlButton>
      </ButtonContainer>
    </Container>
  )
}
